export default __webpack_public_path__ + "static/media/florida.bfe23522.svg";